<template>
    <footer class="bg-dim_dark m-6 py-12">
        <div class="container mx-auto">
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-3">
                    <router-link tag="a" to="/">
                        <img src="@/assets/img/logow.svg" class="h-14 mb-6">
                    </router-link>
                    <p class="text-sm mb-8  text-white">
                        Компания Nevado Premier - авторские натяжные потолки премиального качесва.
                        <br><br>
                        Данный сайт носит информационный характер и ни при каких условиях не является публичной офертой         
                    </p>
                    <button class="px-6 w-full rounded py-4 text-xl text-black bg-dim_gold_2 border border-solid border-dim_gold_2 hover:border-white hover:bg-transparent hover:text-white">Смотреть работы</button>
                </div>
                <div class="col-span-3 col-start-5">
                    <h6 class="text-dim_gold_2 text-lg font-semibold mb-6">УСЛУГИ</h6>
                    <ul>
                        <li class="mb-2"><a href="" class="text-white hover:text-dim_gold_2">Производство натяжных потолков</a></li>
                        <li class="mb-2"><a href="" class="text-white hover:text-dim_gold_2">Онлайн- сопровождение проекта</a></li>
                        <li class="mb-2"><a href="" class="text-white hover:text-dim_gold_2">Оффлайн сопровождение проекта</a></li>
                        <li class="mb-2"><a href="" class="text-white hover:text-dim_gold_2">Консультация project-менеджера по вопросам проекта</a></li>
                        <li class="mb-2"><a href="" class="text-white hover:text-dim_gold_2">Дизайн проект потолка</a></li>
                        <li class="mb-2"><a href="" class="text-white hover:text-dim_gold_2">Замер от ведущих технологов</a></li>
                        <li class="mb-2"><a href="" class="text-white hover:text-dim_gold_2">Установка потолочных решений любой сложности</a></li>
                        <li class="mb-2"><a href="" class="text-white hover:text-dim_gold_2">Установка световых решений любой сложности</a></li>
                        <li class="mb-2"><a href="" class="text-white hover:text-dim_gold_2">Установка потолочных и световых решений под ключ</a></li>
                    </ul>
                </div>
                <div class="col-span-2">
                    <h6 class="text-dim_gold_2 text-lg font-semibold mb-6">КАРТА САЙТА</h6>
                    <ul>
                        <li class="mb-2"><a href="" class="text-white hover:text-dim_gold_2">О компании</a></li>
                        <li class="mb-2"><a href="" class="text-white hover:text-dim_gold_2">Услуги</a></li>
                        <li class="mb-2"><a href="" class="text-white hover:text-dim_gold_2">Виды решений</a></li>
                        <li class="mb-2"><a href="" class="text-white hover:text-dim_gold_2">Галерея работ</a></li>
                        <li class="mb-2"><a href="" class="text-white hover:text-dim_gold_2">3D Туры</a></li>
                        <li class="mb-2"><a href="" class="text-white hover:text-dim_gold_2">Новости</a></li>
                        <li class="mb-2"><a href="" class="text-white hover:text-dim_gold_2">Контакты</a></li>
                        <li class="mb-2"><a href="" class="text-white hover:text-dim_gold_2">Освещение</a></li>
                    </ul>
                </div>
                <div class="col-span-3">
                    <div class="p-8 bg-[#3d3d3d]">
                        <div class="bg-[url('https://premier.nevado.ru/wp-content/uploads/2021/10/tours-1.png')] bg-cover bg-center bg-no-repeat rounded-full h-20 w-20 mx-auto -mt-16 border-[6px] border-dim_dark mb-4 relative">
                            <div class="h-3 w-3 rounded-full absolute bottom-[4px] right-[4px] bg-[#5BF13E] border-2 border-dim_dark"></div>
                        </div>

                        <h6 class="text-dim_gold_2 text-lg font-semibold mb-8 uppercase text-center">Контакты</h6>
                        <p class="mb-2 text-center"><span class="mdi mdi-phone-outline text-dim_gold_2 mr-2"></span><a href="" class="text-white font-semibold hover:text-dim_gold_2">8 (812) 439-16-38</a></p>
                        <p class="mb-8 text-center"><span class="mdi mdi-email-outline text-dim_gold_2 mr-2"></span><a href="" class="text-white font-semibold hover:text-dim_gold_2">zakaz@nevado.ru</a></p>
                        <button class="rounded w-full text-xl text-white hover:text-dim_gold_2">Карта<span class="mdi mdi-arrow-right ml-2 text-lg"></span></button>
                    </div>
                </div>
                <div class="col-span-6 my-6 flex items-center">
                    <h6 class="text-dim_gold_2 text-lg font-semibold mr-12">МЫ В СОЦСЕТЯХ</h6>
                    <a href="https://wa.me/79817777147" target="_blank">
                        <img src="@/assets/img/whats.svg" alt="">
                    </a>
                </div>
                <div class="col-span-6 my-6 text-right">
                    <p class="text-md">
                        <a href="https://premier.nevado.ru/privacy" target="_blank" class="text-white underline hover:text-dim_gold_2 hover:no-underline">Политика конфиденциальности</a>      
                    </p>
                </div>
                <div class="col-span-12 flex justify-between items-center pt-12 border-t border-[#ffffff33]">
                    <p class="text-sm text-white">© Nevado Premier - {{date}}</p>
                    <p class="text-sm text-white hover:underline"><a href="https://webink.site/" target="_blank">Разработано в компании -<img src="@/assets/img/webink.svg" class="inline-block ml-2"></a></p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    data(){
        return {
            date: new Date().getFullYear()
        }
    }
}
</script>